import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const BusinessAdministrationCareerSkills = ({ componentData }) => {
  // Parse content into paragraphs (split by double line breaks). Strip the
  // legacy "Discover our…" call-to-action wherever it appears so the section
  // flows cleanly into the new Course Duration / Benefits sections below.
  const paragraphs = (componentData?.content
    ? componentData.content.split(/\n\n+/).filter(p => p.trim())
    : [
        `Business Administration is the backbone of every successful organization. At JRIIT, our Business Administration program teaches you the essential skills needed to plan, manage, and grow organizations across any industry. From financial management and marketing to human resources and strategic planning, you will graduate with the knowledge and confidence to lead teams, start your own business, or advance into management roles in Tanzania's growing economy.`,
        `Why JRIIT? We emphasize practical, real-world business scenarios rather than traditional approaches. You will receive detailed feedback on your business strategies and management approaches, giving you a comprehensive understanding of your professional growth.`,
      ]
  ).filter((p) => !/^\s*discover our\b/i.test(p));

  const title = componentData?.title || "BUSINESS-READY SKILLS? CHECK.";

  return (
    <CareerSkillsSection
      title={title}
      paragraphs={paragraphs}
    />
  );
};

export default BusinessAdministrationCareerSkills;
